<svelte:options
  customElement={{
    tag: "oc-divider-v1",

    extend: window.__components.extend(),
    props: {
      variant: { type: "String" },
      orientation: { type: "String", reflect: true },
      inFlow: { type: "Boolean", attribute: "in-flow", reflect: true },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./DividerV1.types.js";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { orientation = "horizontal", inFlow = false, variant = "solid" }: Props = $props();
</script>

<div
  class="divider"
  class:divider--in-flow={inFlow}
  class:divider--vertical={orientation === "vertical"}
  class:divider--dashed={variant === "dashed"}
></div>

<DefaultStyles display="block" />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";
  :global {
    :host {
      position: relative;
      width: inherit;
    }

    :host([orientation="vertical"]) {
      height: inherit;
    }

    .divider {
      position: absolute;
      display: block;
      left: 0;
      width: 100%;
      height: tokens.$oc-component-divider-border-width;
      background: linear-gradient(
        tokens.$oc-component-divider-border-color,
        tokens.$oc-component-divider-border-color
      );

      &--in-flow {
        position: relative;
      }

      &--dashed {
        background: repeating-linear-gradient(
          to right,
          tokens.$oc-component-divider-border-color 0,
          tokens.$oc-component-divider-border-color 4px,
          transparent 4px,
          transparent 8px
        );
      }

      &--vertical {
        left: unset;
        top: 0;
        width: tokens.$oc-component-divider-border-width;
        height: 100%;
        background: linear-gradient(
          to right,
          tokens.$oc-component-divider-border-color,
          tokens.$oc-component-divider-border-color
        );

        &.divider--dashed {
          background: repeating-linear-gradient(
            to bottom,
            tokens.$oc-component-divider-border-color 0,
            tokens.$oc-component-divider-border-color 4px,
            transparent 4px,
            transparent 8px
          );
        }
      }
    }
  }
</style>
